import { render, staticRenderFns } from "./videoConfSectionMain.vue?vue&type=template&id=18b5f212&lang=pug"
import script from "./videoConfSectionMain.vue?vue&type=script&lang=js"
export * from "./videoConfSectionMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports